export function isDebugEnabled(): boolean {
  if (typeof window !== 'undefined') {
    try {
      if (localStorage.getItem('safework_debug') === '1') {
        return true;
      }
    } catch {
      // localStorage may be unavailable (e.g. private browsing restrictions)
    }
  }

  return process.env.REACT_APP_DEBUG === 'true';
}

export function debugLog(...args: unknown[]): void {
  if (isDebugEnabled()) {
    console.log(...args);
  }
}
